import { render, staticRenderFns } from "./PreScreeningEditor.vue?vue&type=template&id=a01753c6&"
import script from "./PreScreeningEditor.vue?vue&type=script&lang=js&"
export * from "./PreScreeningEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports